// extracted by mini-css-extract-plugin
export default {"hideTooltip":"B_-z","fadeIn":"C_-z","delay":"D_-z","recommendedSizeTooltip":"E_-z"};